import React, { PropTypes } from 'react';
import $ from 'jquery';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.title) {
    errors.title = true;
  }

  return errors;
};

class TipForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    fileName: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: props.fileName,
    };

    this.onSelectFile = this.onSelectFile.bind(this);
    this.onRemoveFile = this.onRemoveFile.bind(this);
    this.onFileSelected = this.onFileSelected.bind(this);
  }

  onSelectFile() {
    $(this.refs.file).click();
  }

  onRemoveFile() {
    const { fields } = this.props;

    fields['attachmentId'].onChange(undefined);
    this.setState({
      fileName: undefined,
    });
  }

  onFileSelected(evt) {
    const { fields } = this.props;

    const file = evt.target.files[0];
    if (file) {
      fields['attachment'].onChange(file);
      this.setState({
        fileName: file.name,
      });
    }
  }

  render() {
    const { fields: { title, attachment, attachmentId } } = this.props;

    const { fileName } = this.state;

    return (
      <form className="ui form">
        <div className={fieldClass(title)}>
          <label>Titre</label>
          <input type="text" name="title" placeholder="Titre" {...title} />
        </div>
        <div className="ui field">
          <label>Fichier joint</label>
          <div className="ui fluid action input">
            <input type="text" {...attachmentId} style={{ display: 'none' }} />
            <input
              type="file"
              {...attachment}
              value={null}
              ref="file"
              onChange={this.onFileSelected}
            />
            <input
              type="text"
              value={fileName}
              readOnly
              onClick={this.onSelectFile}
            />
            <div className="ui icon button" onClick={this.onSelectFile}>
              <i className="cloud upload icon" />
            </div>
            {(fileName || (attachmentId && attachmentId.value)) && (
              <div className="ui red icon button" onClick={this.onRemoveFile}>
                <i className="close icon" />
              </div>
            )}
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm(
  {
    form: 'tip',
    fields: ['title', 'attachment', 'attachmentId'],
    validate,
  },
  state => {
    const { tip } = state.tips.tip;

    let attachmentId, fileName;
    if (tip.attachment) {
      attachmentId = tip.attachment.id;
      fileName = tip.attachment.name;
    }

    return {
      initialValues: {
        title: tip.title,
        attachmentId,
      },
      fileName,
    };
  }
)(TipForm);



// WEBPACK FOOTER //
// ./src/modules/tip/components/TipForm.js